import React from "react";
import { FacilityOrderTemplateNewFlowEditTemplate } from "themes/application/facility-order-new-flow/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderTemplateNewFlowEdit extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowEditTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowEdit;